import { useTranslation } from '@simplywallst/hooks/useTranslation';
import type * as StatementTranslation from '@assets/locales/en/statementGlossary.json';
import { useCallback } from 'react';

/**
 *
 * See [useTranslation]{@link ./useTranslation.ts} for usage.
 */
export const useStatementTranslation = () => {
  const { t } = useTranslation<
    'statementGlossary',
    keyof typeof StatementTranslation
  >();

  const translate = useCallback(
    (key: keyof typeof StatementTranslation): string => {
      return t(key, { ns: 'statementGlossary' });
    },
    [t]
  );

  const translateWithoutTyping = useCallback(
    (key: string): string => {
      return t(key, { ns: 'statementGlossary' });
    },
    [t]
  );

  return {
    t: translate,
    translateWithoutTyping,
  };
};
